import React, { useState, useEffect } from "react";
import { Radio, Form, Input, Button, DatePicker, Select, Checkbox } from "antd";
// import { postRiderBrake, RiderOngoingShift,} from "../../../../../../services/riders.service";
// import { openNotification, swalNotification } from "../../../../../../components/alret/notificztion";
import { breakPlainOptionsreason, breakPlainOptionsTime } from "../../../../../../utils/Helpers";
import moment from "moment";
import * as breakActions from "../../../../../../redux/actions/break.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Option } = Select;
const plainOptionsReassign = [
  {
    label: "None",
    value: "none",
  },
  // {
  //   label: "TMP",
  //   value: "tmp",
  // },
  {
    label: "Break",
    value: "break",
  },
];

const RiderBrakeMark = (props) => {
  const [MBtnLoading, setMBtnLoading] = useState(false);
  // Reassign Radio Button
  const [valueBrakeReassign, setValueBrakeReassign] = useState("none");
  const [valueBrakeval, setValueBrakeval] = useState(null);

  const onChangeReassign = (val) => {
    const dataTid = {
      riderId: props.brakeRiderid,
      type: val.target.value,
    };
    setValueBrakeval(dataTid);
    setValueBrakeReassign(val.target.value);
  };

  const [filter, setFilter] = useState("");
  const setFiltervalue = (value) => {
    setFilter(value);
  };

  const disabledDate = (current) => {
    return current && current < moment().endOf("day").add(-1, "days");
  };

  const riderBrakeSubmit = async (values) => {
    const dataTid = {
      ...values,
      riderId: props.brakeRiderid,
      is_forced_break: values.is_forced_break === true?1:0,
    };
    try {
      setMBtnLoading(true);
      await props.breakActions.breakMarkAction(dataTid);
    } catch (e) {} finally {
      setMBtnLoading(false);
    }
  };

  useEffect(() => {
    if (valueBrakeval) {
      form.setFieldsValue(valueBrakeval);
    }
  }, [valueBrakeval]);
  const [form] = Form.useForm();
  return (
    <>
      <Radio.Group
        options={plainOptionsReassign}
        onChange={onChangeReassign}
        defaultValue={plainOptionsReassign[0]}
        value={valueBrakeReassign}
      />
      {valueBrakeval && (
        <Form
          form={form}
          layout="vertical"
          initialValues={valueBrakeval}
          onFinish={riderBrakeSubmit}
          hidden={
            valueBrakeReassign === plainOptionsReassign[0].value ? "hidden" : ""
          }
        >
          <Form.Item hidden name={"type"}>
            <Input />
          </Form.Item>
          <Form.Item hidden name={"riderId"}>
            <Input />
          </Form.Item>
          <Form.Item
            name={"duration"}
            label="Duration"
            rules={[{ required: true, message: "Duration is Required" }]}
          >
            <Select
              placeholder="Duration"
              style={{ width: "100%" }}
              value={filter}
              onChange={setFiltervalue}
            >
              {breakPlainOptionsTime && breakPlainOptionsTime.map((item) => (
                <Option value={item.value}>{item.label}</Option>
              ))}
            </Select>
          </Form.Item>
          {filter == "customize" ? (
            <Form.Item
              name={"startDate"}
              label="Start Date"
              rules={[
                {
                  required: true,
                  message: "Please add start date time",
                },
              ]}
            >
              <DatePicker
                format="YYYY-MM-DD HH:mm:ss"
                disabledDate={disabledDate}
                showTime={{
                  defaultValue: moment("00:00:00", "HH:mm:ss"),
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          ) : (
            ""
          )}
          {filter == "customize" ? (
            <Form.Item
              name={"endDate"}
              label="End Date"
              rules={[
                {
                  required: true,
                  message: "Please add end date time",
                },
              ]}
            >
              <DatePicker
                format="YYYY-MM-DD HH:mm:ss"
                disabledDate={disabledDate}
                showTime={{
                  defaultValue: moment("00:00:00", "HH:mm:ss"),
                }}
                style={{ width: "100%" }}
              />
            </Form.Item>
          ) : (
            ""
          )}
          <Form.Item
            name={"reason"}
            label="Reason"
            rules={[{ required: true, message: "Reason is Required" }]}
          >
            <Select
              placeholder="Reason for Assigning"
            >
              {breakPlainOptionsreason &&
                breakPlainOptionsreason.map((item) => (
                  <Option value={item.value}>{item.label}</Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item name={"is_forced_break"} valuePropName="checked">
            <Checkbox>Forced Break</Checkbox>
          </Form.Item>
          <Form.Item>
            <Button loading={MBtnLoading} htmlType="submit">
              Submit Rider Break
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {

  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    breakActions: bindActionCreators(breakActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RiderBrakeMark);


